import { createEvent } from 'effector';

import { MedicineManagementState } from './MedicineManagementState';

export const medicineManagementEvent =
  createEvent<Partial<MedicineManagementState>>('medicineManagementEvent');
